import { ListView } from '@onegov/react-component-library';
import { Heading } from '@snsw/react-component-library';
import { PagePath } from 'shared/constants/pagePath';
import _ from 'lodash';
import { PlantDesignDrawingAndTechDetailsPage } from 'plantDesign/constants/plantDesignDrawingAndTechDetailsPage';
import { removeDrawing } from 'plantDesign/redux/plantDesignDrawingAndTechSlice';
import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from '../DrawingsAndTechDetails.module.scss';

export const DrawingListView = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    items = [],
    errorMessage = '',
    hasError = false,
    id = '',
    showHeading = true,
    showEditRemove = true,
    showAddButton = true,
    applicationId,
  } = props;

  const PageConstant = PlantDesignDrawingAndTechDetailsPage.drawingList;

  const onAddDrawingClick = () => {
    let designDrawings = _.cloneDeep(items);

    //max drawings is 3
    if (designDrawings.length >= 3) return;

    designDrawings.push({});

    navigate(PagePath.plantDesignAddDrawing, { state: { drawings: designDrawings, applicationId } });
  };

  const onEditDrawingClick = () => {
    const designDrawings = _.cloneDeep(items);
    navigate(PagePath.plantDesignAddDrawing, { state: { drawings: designDrawings, applicationId } });
  };

  const renderRowTitleDrawingListView = (index, drawingDetails) => {
    return (
      <div key={`title_${index}`} className={styles.listViewTitle}>{`${(index + 1).toString().padStart(2, '0')} ${
        PageConstant.drawingDetailLabel
      }`}</div>
    );
  };

  const renderRowDetailsDrawingListView = (index, drawingDetails) => {
    return (
      <Fragment key={`detail_${index}`}>
        <div className={styles.listViewDetailsValue}>
          {PageConstant.drawingTitleLabel + ': ' + drawingDetails.title}
        </div>
        <div className={styles.listViewDetailsValue}>
          {PageConstant.drawingNumberLabel + ': ' + drawingDetails.number}
        </div>
        {drawingDetails.revisionNumber && (
          <div className={styles.listViewDetailsValue}>
            {PageConstant.drawingRevisionNumberLabel + ': ' + drawingDetails.revisionNumber}
          </div>
        )}
        <div className={styles.listViewDetailsValue}>
          {drawingDetails.uploadedDocument && drawingDetails.uploadedDocument[0]?.name}
        </div>
      </Fragment>
    );
  };

  const onRemoveDrawing = (index, drawingDetails) => {
    dispatch(removeDrawing(index));
  };

  return (
    <>
      {showHeading && <Heading level={2}>{PageConstant.drawingListTitle}</Heading>}
      <div>
        <strong>{PageConstant.drawingListHelpMessage}</strong>
      </div>
      <div id={id}>
        <ListView
          title=""
          buttonAddTitle={`+ Add  ${items.length > 0 ? 'another' : ''}  drawing`}
          items={items}
          confirmationTitle="Are you sure you want to remove this drawing?"
          confirmationDescription="This will delete all details for the drawing."
          onRemove={onRemoveDrawing}
          maxItemLimit={3}
          renderRowTitle={renderRowTitleDrawingListView}
          renderRowDetails={renderRowDetailsDrawingListView}
          onAdd={onAddDrawingClick}
          onEdit={onEditDrawingClick}
          errorMessage={errorMessage}
          hasError={hasError}
          showEditRemove={showEditRemove}
          showAddButton={showAddButton}
        />
      </div>
    </>
  );
};
